import { z, ZodType } from 'zod';
import { jObjectBase, jObjectBaseSchema, jObjectLittle } from './objectBase';
import { jUserLittle } from './user';

export const jLinkLittleSchema = jObjectBaseSchema.extend({
    srcId: z.number(),
    srcType: z.string(),
    targetId: z.number(),
    targetType: z.string().nullable(),
});
export type jLinkLittle = z.infer<typeof jLinkLittleSchema>;

export const inferJLinkListSchema = <T extends ZodType<jObjectBase>>(type: T) => {
    return jLinkLittleSchema.extend({
        value: z.string().nullable(),
        _src: type.optional(),
        _target: type.optional().or(z.undefined()),
    });
};
export type jLinkList<T extends jObjectBase = jObjectLittle | jUserLittle> = z.infer<
    ReturnType<typeof inferJLinkListSchema<ZodType<T>>>
>;
